import { applicationApi } from "common/api";
import { QuestionaireResponse, StartQuestionaireRequest } from "models/flQuestionaire";

// Define a service using a base URL and expected endpoints
export const questionaireLandingApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    startQuestionaire: builder.mutation<QuestionaireResponse, StartQuestionaireRequest>({
      query: (body) => ({
        url: `bdc/questionaire/start`,
        method: "POST",
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useStartQuestionaireMutation } = questionaireLandingApi;
